import { VacanciesTemplatesListPage } from '@pages/vacanciesTemplates';

export default VacanciesTemplatesListPage;
